import React from 'react';
import { 
    Create, 
    SimpleForm, 
    TextInput, 
    DateInput,
    SelectInput,
    BooleanInput,
    NumberInput,
    required,
    email,
    minLength,
    maxLength,
    number
} from 'react-admin';
import { Typography, Box } from '@mui/material';
import { FormToolbar } from "../../common/FormToolbar";

// Blood group choices
const bloodGroupChoices = [
    { id: 'A+', name: 'A+' },
    { id: 'A-', name: 'A-' },
    { id: 'B+', name: 'B+' },
    { id: 'B-', name: 'B-' },
    { id: 'AB+', name: 'AB+' },
    { id: 'AB-', name: 'AB-' },
    { id: 'O+', name: 'O+' },
    { id: 'O-', name: 'O-' },
];

// Gender choices
const genderChoices = [
    { id: 'male', name: 'Male' },
    { id: 'female', name: 'Female' },
    { id: 'other', name: 'Other' },
];

// City choices
const cityChoices = [
    { id: 'Ajmer', name: 'Ajmer' },
    { id: 'Bhilwara', name: 'Bhilwara' },
    { id: 'Beawar', name: 'Beawar' },
    { id: 'Parbatsar', name: 'Parbatsar' },
];

const SectionTitle = ({ children }) => (
    <Box sx={{ mt: 3, mb: 2 }}>
        <Typography variant="h6" gutterBottom>
            {children}
        </Typography>
    </Box>
);

export const StudentCreate = props => {
    return (
        <React.Fragment>
            <Create label="Create Student" {...props}>
                <SimpleForm toolbar={<FormToolbar {...props} />} className="main-form">
                    {/* Personal Information */}
                    <SectionTitle>Personal Information</SectionTitle>
                    
                    <TextInput 
                        source="first_name" 
                        label='First Name' 
                        fullWidth={true} 
                        className="first_inline_input"
                        validate={[required()]} 
                    />
                    <TextInput 
                        source="middle_name" 
                        label='Middle Name' 
                        fullWidth={true}
                        className="last_inline_input"
                    />
                    <TextInput 
                        source="last_name" 
                        label='Last Name' 
                        fullWidth={true}
                        className="first_inline_input"
                        validate={[required()]} 
                    />
                    <DateInput 
                        source="date_of_birth" 
                        label='Date of Birth' 
                        fullWidth={true}
                        className="last_inline_input"
                        validate={[required()]} 
                    />
                    <SelectInput 
                        source="gender" 
                        label="Gender" 
                        choices={genderChoices} 
                        validate={[required()]} 
                        fullWidth={true}
                        className="first_inline_input"
                    />
                    <SelectInput 
                        source="blood_group" 
                        label="Blood Group" 
                        choices={bloodGroupChoices} 
                        fullWidth={true}
                        className="last_inline_input"
                    />
                    
                    {/* Contact Information */}
                    <SectionTitle>Contact Information</SectionTitle>
                    
                    <TextInput 
                        source="mobile_number" 
                        label='Mobile Number' 
                        fullWidth={true}
                        className="first_inline_input"
                        validate={[required(), minLength(10), maxLength(10)]} 
                        helperText="10-digit mobile number"
                    />
                    <TextInput 
                        source="email" 
                        label='Email' 
                        fullWidth={true}
                        className="last_inline_input"
                        validate={[email()]}
                    />
                    <TextInput 
                        source="address" 
                        label='Address' 
                        fullWidth={true} 
                        multiline 
                        rows={3}
                    />
                    <SelectInput 
                        source="city" 
                        label="City" 
                        choices={cityChoices} 
                        fullWidth={true}
                        className="first_inline_input"
                    />
                    <TextInput 
                        source="state" 
                        label='State' 
                        fullWidth={true}
                        className="last_inline_input"
                        defaultValue="Rajasthan"
                    />
                    <TextInput 
                        source="pincode" 
                        label='Pincode' 
                        fullWidth={true}
                        className="first_inline_input"
                        validate={[minLength(6), maxLength(6)]}
                    />
                    <TextInput 
                        source="aadhar_number" 
                        label='Aadhar Number' 
                        fullWidth={true}
                        className="last_inline_input"
                        validate={[minLength(12), maxLength(12)]}
                        helperText="12-digit Aadhar number"
                    />
                    
                    {/* Father Information */}
                    <SectionTitle>Father Information</SectionTitle>
                    
                    <TextInput 
                        source="father_name" 
                        label='Father Name' 
                        fullWidth={true}
                        className="first_inline_input"
                    />
                    <TextInput 
                        source="father_mobile" 
                        label='Father Mobile' 
                        fullWidth={true}
                        className="last_inline_input"
                        validate={[minLength(10), maxLength(10)]}
                    />
                    <TextInput 
                        source="father_occupation" 
                        label='Father Occupation' 
                        fullWidth={true} 
                    />
                    
                    {/* Mother Information */}
                    <SectionTitle>Mother Information</SectionTitle>
                    
                    <TextInput 
                        source="mother_name" 
                        label='Mother Name' 
                        fullWidth={true}
                        className="first_inline_input"
                    />
                    <TextInput 
                        source="mother_mobile" 
                        label='Mother Mobile' 
                        fullWidth={true}
                        className="last_inline_input"
                        validate={[minLength(10), maxLength(10)]}
                    />
                    <TextInput 
                        source="mother_occupation" 
                        label='Mother Occupation' 
                        fullWidth={true} 
                    />
                    
                    {/* Guardian Information */}
                    <SectionTitle>Guardian Information (if different from parents)</SectionTitle>
                    
                    <TextInput 
                        source="guardian_name" 
                        label='Guardian Name' 
                        fullWidth={true}
                        className="first_inline_input"
                    />
                    <TextInput 
                        source="guardian_mobile" 
                        label='Guardian Mobile' 
                        fullWidth={true}
                        className="last_inline_input"
                        validate={[minLength(10), maxLength(10)]}
                    />
                    <TextInput 
                        source="guardian_relation" 
                        label='Guardian Relation' 
                        fullWidth={true}
                        className="first_inline_input"
                        helperText="e.g., Uncle, Aunt, Elder Brother"
                    />
                    <TextInput 
                        source="emergency_contact" 
                        label='Emergency Contact' 
                        fullWidth={true}
                        className="last_inline_input"
                        validate={[minLength(10), maxLength(10)]}
                    />
                    
                    {/* Academic History */}
                    <SectionTitle>Previous Academic Information</SectionTitle>
                    
                    <TextInput 
                        source="previous_school" 
                        label='Previous School' 
                        fullWidth={true}
                        className="first_inline_input"
                    />
                    <TextInput 
                        source="previous_class" 
                        label='Previous Class' 
                        fullWidth={true}
                        className="last_inline_input"
                        helperText="Class from which student passed (e.g., 8, 9, 10)"
                    />
                    <NumberInput 
                        source="previous_percentage" 
                        label='Previous Percentage' 
                        fullWidth={true} 
                        min={0}
                        max={100}
                        step={0.01}
                    />
                    
                    {/* Additional Information */}
                    <SectionTitle>Additional Information</SectionTitle>
                    
                    <TextInput 
                        source="photo_url" 
                        label='Photo URL' 
                        fullWidth={true} 
                        helperText="URL of student photo"
                    />
                    <TextInput 
                        source="remarks" 
                        label='Remarks' 
                        fullWidth={true} 
                        multiline 
                        rows={3}
                        helperText="Any additional notes about the student"
                    />
                    <BooleanInput 
                        source="is_active" 
                        label="Active" 
                        defaultValue={true}
                    />
                </SimpleForm>
            </Create>
        </React.Fragment>
    );
}
